<div class="action-bar">
  <div class="buttons" [class.buttons--flyer-open]="flyerVisible || pdfMenuVisible">
    @if (!currentStep?.hidePreviousStepAction && !isPreviousStepDisabled()) {
      <div class="button">
        <ng-casto-button [faIcon]="faArrowLeft" class="secondary borderless" (click)="previous()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.previous' | translate"></span>
      </div>
    }

    @if (currentStep?.displayAddProductButton && !projectLocked && !isCarpentryOrderSent) {
      <div class="button">
        <ng-casto-button [faIcon]="faPlus" class="secondary borderless" (click)="addProduct()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.add-product-btn' | translate"></span>
      </div>
    }

    @if (!currentStep?.hideDiscountAction) {
      <div class="button discount-button-wrapper">
        <ng-casto-button
          [locked]="projectLocked"
          [faIcon]="faPercentage"
          class="secondary borderless"
          (click)="flyerVisible = !flyerVisible"
          [disabled]="projectLocked || printLoading || pricingLoading"
          [loading]="pricingLoading"
          [ngClass]="{
            'discount-5': currentDiscount === DiscountTypeEnum.Discount5,
            'discount-10': currentDiscount === DiscountTypeEnum.Discount10,
            'discount-20': currentDiscount === DiscountTypeEnum.Discount20,
          }"></ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.discount' | translate"></span>
        <div
          class="flyer"
          [ngClass]="{
            visible: flyerVisible,
            hidden: !flyerVisible,
          }">
          <div class="flyer-content">
            <span class="flyer-label" [innerHTML]="'action-bar.discount-note' | translate"> </span>
            <span class="flyer-buttons">
              <ng-casto-button
                label="5%"
                [ngClass]="{
                  'secondary borderless': currentDiscount !== DiscountTypeEnum.Discount5,
                  action: currentDiscount === DiscountTypeEnum.Discount5,
                }"
                (click)="updateDiscount(DiscountTypeEnum.Discount5)"></ng-casto-button>
              <ng-casto-button
                label="10%"
                [ngClass]="{
                  'secondary borderless': currentDiscount !== DiscountTypeEnum.Discount10,
                  action: currentDiscount === DiscountTypeEnum.Discount10,
                }"
                (click)="updateDiscount(DiscountTypeEnum.Discount10)"></ng-casto-button>
              <ng-casto-button
                label="20%"
                [ngClass]="{
                  'secondary borderless': currentDiscount !== DiscountTypeEnum.Discount20,
                  action: currentDiscount === DiscountTypeEnum.Discount20,
                }"
                (click)="updateDiscount(DiscountTypeEnum.Discount20)"></ng-casto-button>
              <ng-casto-button
                label="Sans remise"
                [ngClass]="{
                  'secondary borderless': currentDiscount !== DiscountTypeEnum.Discount0,
                  action: currentDiscount === DiscountTypeEnum.Discount0,
                }"
                (click)="updateDiscount(DiscountTypeEnum.Discount0)"></ng-casto-button>
            </span>
          </div>
        </div>
      </div>
    }

    @if (currentStep?.canPrint) {
      <div class="button pdf-button-wrapper">
        <ng-casto-button
          [faIcon]="faPrint"
          [loading]="printLoading"
          [disabled]="!canPrint || printLoading"
          class="secondary borderless"
          (click)="pdfMenuVisible = !pdfMenuVisible">
        </ng-casto-button>
        <span class="button-label">PDF</span>
        <div
          class="flyer pdf-flyer"
          [ngClass]="{
            visible: pdfMenuVisible,
            hidden: !pdfMenuVisible,
          }">
          <div class="flyer-content">
            <span class="flyer-buttons">
              <ng-casto-button
                [label]="'action-bar.print' | translate"
                [faIcon]="faPrint"
                [loading]="printLoading"
                (click)="print(); pdfMenuVisible = false"
                class="secondary borderless">
              </ng-casto-button>
              <ng-casto-button
                [label]="'action-bar.email' | translate"
                [faIcon]="faEnvelope"
                [loading]="printLoading"
                (click)="sendEmail(); pdfMenuVisible = false"
                class="secondary borderless">
              </ng-casto-button>
            </span>
          </div>
        </div>
      </div>
    }

    @if (currentStep?.canSendMail) {
      <div class="button">
        <ng-casto-button
          [faIcon]="faEnvelope"
          [loading]="sendMailLoading"
          [disabled]="sendMailLoading"
          class="secondary borderless"
          (click)="sendQuoteByMail()">
        </ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.email' | translate"></span>
      </div>
    }

    @if (!currentStep?.hideProductList) {
      <div class="button">
        <ng-casto-button
          [faIcon]="faList"
          [disabled]="isProductListDisabled"
          class="action"
          (click)="showProductList()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.product-list' | translate"></span>
      </div>
    }

    @if (isCarpentry) {
      <div class="button">
        <ng-casto-button
          [faIcon]="faPen"
          [disabled]="!isOrderSentToComPlus"
          [loading]="orderEditionLoading"
          class="action"
          (click)="openCartOrderEdition()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'popins.products_list.aside.order-number-title' | translate"></span>
      </div>
    }

    @if (projectLocked && canUnlockProject) {
      <div class="button">
        <ng-casto-button
          [faIcon]="faUnlock"
          [loading]="unlockLoading"
          class="action"
          (click)="unlockProject()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.unlock' | translate"></span>
      </div>
    }
    @if (!finalStep) {
      <div class="button">
        <ng-casto-button
          [faIcon]="faSave"
          [loading]="saveLoading"
          [disabled]="saveLoading || projectLocked"
          class="secondary borderless"
          (click)="saveWithoutNavigation()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'generic.save' | translate"></span>
      </div>
      <div class="button">
        <ng-casto-button
          [faIcon]="faArrowRight"
          [disabled]="!canNextStep || tunnelLoading || beforeNextProcessing"
          [loading]="beforeNextProcessing || tunnelLoading"
          class="action"
          (click)="next()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.next' | translate"></span>
      </div>
    } @else if (!projectLocked) {
      <div class="button">
        <ng-casto-button
          [faIcon]="faSave"
          [loading]="saveLoading"
          [disabled]="saveLoading"
          class="secondary borderless"
          (click)="save()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'generic.save' | translate"></span>
      </div>

      @if (isKitchen) {
        <div class="button">
          <ng-casto-button
            [faIcon]="faPaperPlane"
            [loading]="comPlusLoading"
            [disabled]="projectLocked || !featureSettingsService.poseEnabled"
            [locked]="projectLocked"
            class="action"
            (click)="orderPrevisitKitchen()"></ng-casto-button>
          <span class="button-label" [innerHTML]="'action-bar.previsit_kitchen' | translate"></span>
        </div>
      }

      @if (isStorage) {
        <div class="button">
          <ng-casto-button
            [faIcon]="faPaperPlane"
            [loading]="comPlusLoading"
            [disabled]="projectLocked || !featureSettingsService.poseEnabled"
            [locked]="projectLocked"
            class="action"
            (click)="orderPrevisitStorage()"></ng-casto-button>
          <span class="button-label" [innerHTML]="'action-bar.previsit_storage' | translate"></span>
        </div>
      }

      @if (isBathroomHbm) {
        <div class="button">
          <ng-casto-button
            [faIcon]="faPaperPlane"
            [loading]="comPlusLoading"
            [disabled]="projectLocked || !featureSettingsService.poseEnabled"
            [locked]="projectLocked"
            class="action"
            (click)="orderPrevisitBathroomHbm()"></ng-casto-button>
          <span class="button-label" [innerHTML]="'action-bar.previsit_bathroom' | translate"></span>
        </div>
      }

      @if (isBathroomV2) {
        <div class="button">
          <ng-casto-button
            [faIcon]="faPaperPlane"
            [loading]="comPlusLoading"
            [disabled]="projectLocked || !featureSettingsService.poseEnabled"
            [locked]="projectLocked"
            class="action"
            (click)="orderPrevisitBathroom()"></ng-casto-button>
          <span class="button-label" [innerHTML]="'action-bar.previsit_bathroom' | translate"></span>
        </div>
      }

      @if (isPrevisitWorkbench) {
        <div class="button">
          <ng-casto-button
            [faIcon]="faPaperPlane"
            [loading]="comPlusLoading"
            [disabled]="projectLocked || !featureSettingsService.poseEnabled"
            [locked]="projectLocked"
            class="action"
            (click)="orderPrevisitWorkbench()"></ng-casto-button>
          <span class="button-label" [innerHTML]="'action-bar.previsit_workbench' | translate"></span>
        </div>
      }

      @if (isCarpentry) {
        <div class="button">
          <ng-casto-button
            [faIcon]="faPaperPlane"
            [loading]="comPlusLoading"
            [disabled]="projectLocked || isCarpentryOrderSent || !featureSettingsService.poseEnabled"
            [locked]="projectLocked || isCarpentryOrderSent"
            class="action"
            (click)="orderPrevisitCarpentry()"></ng-casto-button>
          <span class="button-label" [innerHTML]="'action-bar.previsit_carpentry' | translate"></span>
        </div>
      }

      <div class="button">
        <ng-casto-button
          [faIcon]="faPaperPlane"
          [loading]="comPlusLoading"
          [disabled]="projectLocked || isCarpentryOrderSent"
          [locked]="projectLocked || isCarpentryOrderSent"
          class="action"
          (click)="sendComPlus()"></ng-casto-button>
        <span class="button-label" [innerHTML]="'action-bar.com_plus' | translate"></span>
      </div>
    }
  </div>
</div>
